import { toasts, dismissToast, sheet, closeSheet, dialog, online } from '@/state/ui';
import { sunsetAnnouncement } from '@/lib/theme';
import { Icon } from '@/components/Icon';

export function ToastHost() {
  if (!toasts.value.length) return null;
  return (
    <div class="toast-host">
      {toasts.value.map((t) => (
        <div key={t.id} class={`toast ${t.leaving ? 'is-leaving' : ''}`} role="status">
          {t.kind === 'success' && <Icon name="check" class="toast__icon toast__icon--success" />}
          {t.kind === 'info' && <Icon name="bell" class="toast__icon toast__icon--info" />}
          {t.kind === 'undo' && <Icon name="undo" class="toast__icon toast__icon--info" />}
          <span class="toast__msg">{t.message}</span>
          {t.actionLabel && (
            <button
              class="toast__action"
              onClick={() => {
                t.onAction?.();
                dismissToast(t.id);
              }}
            >
              {t.actionLabel}
            </button>
          )}
        </div>
      ))}
    </div>
  );
}

export function SheetHost() {
  const s = sheet.value;
  if (!s) return null;
  return (
    <>
      <div class={`sheet-backdrop ${s.leaving ? 'is-leaving' : ''}`} onClick={closeSheet} />
      <div class={`sheet ${s.leaving ? 'is-leaving' : ''}`} role="dialog" aria-modal="true" aria-label={s.title}>
        <div class="sheet__handle" />
        {s.title && <h2 class="sheet__title">{s.title}</h2>}
        <div class="sheet__body">{s.content}</div>
      </div>
    </>
  );
}

export function DialogHost() {
  const d = dialog.value;
  if (!d) return null;
  return (
    <div class="dialog-backdrop" onClick={() => (dialog.value = null)}>
      <div class="dialog" role="alertdialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <h2 class="dialog__title">{d.title}</h2>
        <p class="dialog__msg">{d.message}</p>
        <div class="dialog__actions">
          <button class="btn btn--secondary" onClick={() => (dialog.value = null)}>
            Cancel
          </button>
          <button
            class={`btn ${d.danger ? 'btn--danger' : ''}`}
            onClick={() => {
              dialog.value = null;
              d.onConfirm();
            }}
          >
            {d.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export function SunsetPill() {
  const a = sunsetAnnouncement.value;
  if (!a) return null;
  return (
    <div class="sunset-pill" role="status" aria-live="polite">
      <Icon name={a.to === 'dark' ? 'moon' : 'sun'} />
      <span>{a.to === 'dark' ? 'Sunset · switched to dark mode' : 'Sunrise · switched to light mode'}</span>
    </div>
  );
}

export function OfflineBanner() {
  if (online.value) return null;
  return (
    <div class="offline-banner" role="status">
      <Icon name="wifi-off" />
      <span>Offline — changes will sync when you're back</span>
    </div>
  );
}
